<template>
  <div class="orders-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span>{{ $t("sale.orders.title") }}</span>
        <list-search @listSearchEvn="listSearchEvn" />
      </div>
      <!-- <div class="right-part">
                <button class="global-button-style" @click="$router.push({name: 'add'})"><img src="@/assets/img/cmb_btn_add.png"/>{{$t('user.addUser')}}</button>
            </div> -->
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="global-body-wrap">
        <TableView
          :tableProp="tableProp"
          :tableData="tableData"
          :currentPage="currentPage"
          :pageSize="params.limit"
          @tableHandle="tableHandle"
        />
      </div>
      <Pagination
        :pageSize="params.limit"
        :total="total"
        @pageNum="getPageNum"
      />
    </el-card>
  </div>
</template>

<script>
import TableView from "@/components/tableView";
import Pagination from "@/components/pagination";
import ListSearch from "@/components/listSearch";
import listMixin from "@/mixins/list";

export default {
  mixins: [listMixin],
  components: {
    TableView,
    Pagination,
    ListSearch
  },
  computed: {
    tableProp() {
      let tableProp = [
        {
          prop: "user_id",
          label: this.$t("user.id")
        },
        {
          prop: "des",
          label: this.$t("sale.orders.des")
        },
        // {
        //   prop: "vip_type",
        //   label: this.$t("sale.orders.vip_type")
        // },
        {
          prop: "created_at",
          label: this.$t("commonMsg.createdAt")
        },
        {
          prop: "fee_type",
          label: this.$t("sale.orders.fee_type")
        },
        {
          prop: "pay_time",
          label: this.$t("sale.orders.pay_time")
        },
        {
          prop: "order_total",
          label: this.$t("sale.orders.total")
        },
        {
          prop: "orders_status",
          label: this.$t("sale.orders.status")
        },
        {
          prop: "out_trade_no",
          label: this.$t("sale.orders.out_trade_no")
        }
      ];
      return tableProp;
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      currentPage: 1,
      params: { limit: 20, offset: 0 }
    };
  },
  methods: {
    getList() {
      this.$http
        .getOrders(this.params)
        .then(res => {
          this.total = res.data.count;
          this.tableData = res.data.rows;
        })
        .catch(() => {});
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.orders-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
}
</style>
